import type { ScrollOptions } from 'vue-scrollto';

export const VUE_SCROLLTO_OPTIONS: ScrollOptions = {
  duration: 500,
  container: 'body',
  easing: 'ease-out'
};